"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanizeEnumValue = exports.DEFAULT_ACRONYMS = void 0;
// Case-insensitive allowlist of tokens that should render fully upper-case
// (e.g. 'HVAC', not 'Hvac') rather than title-cased.
exports.DEFAULT_ACRONYMS = [
    'HVAC',
    'IAQ',
    'SEER',
    'EER',
    'PM',
    'CO2',
    'UV',
    'ID',
    'QR',
    'HG',
    'AC',
    'DC',
    'CT',
    'LED',
    'OTA',
    'GPS',
    'API',
];
/**
 * This is the FALLBACK label for an enum value with no translation — the
 * translated string always wins; this only keeps a new backend enum member
 * from printing as a dotted key path in the UI (e.g. a missing
 * `serviceRequests.serviceTypes.POWER_MONITOR_SERVICE` key rendering as
 * that literal string instead of "Power Monitor Service").
 */
function humanizeEnumValue(value, opts) {
    if (!value)
        return '';
    const acronyms = new Set([...exports.DEFAULT_ACRONYMS, ...(opts?.acronyms ?? [])]);
    return value
        .split(/[\s_-]+/)
        .filter((token) => token.length > 0)
        .map((token) => {
        const upper = token.toUpperCase();
        if (acronyms.has(upper))
            return upper;
        return upper[0] + token.slice(1).toLowerCase();
    })
        .join(' ');
}
exports.humanizeEnumValue = humanizeEnumValue;
